<template>
	<div>
		<!--<span>{{zReport}}</span>-->
		<div class="modal-header">
			<h3 class="modal-title">Сессия ( Начало : {{zReport.createDate }} - Конец : {{ zReport.endDate
				}})</h3>
			<!--			<button type="button" @click="close" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>-->
		</div>
		<div class="modal-boy" id="toPrintZReport">
			<div class="row">
				<div class="col-sm-12">
					<div class="modal-body box-z-report">
						<template v-if="currentZetReport.total !== '0'">
							<table class="table table-striped table-bordered">
								<tbody>
								<tr v-for="(key,index) in currentZetReport.date">
									<td v-if="index==='QARZGA'">
										В Долг
									</td>
									<td v-if="index==='HOMIYLIK'">
										Спонсорство
									</td>
									<td v-if="index==='CERTIFICATE'">
										Сертификат
									</td>
									<td v-if="index==='CASH'">
										Наличные деньги
									</td>
									<td v-if="index==='BANK_CARD'">
										Банковская карта
									</td>
									<td v-if="index==='BANK_TRANSFER'">
										Перечисления
									</td>

									<td>
											<span class="display_currency" data-currency_symbol="true">{{ key | currency({
												symbol: currencyForZReportView, fractionCount: 2, symbolPosition: 'back',
												thousandsSeparator: ' '
											}) }}
											</span>
									</td>
								</tr>
								<tr class="success">
									<th>
										Общая сумма
									</th>
									<td>
										<b><span class="display_currency" data-currency_symbol="true">{{zReport.total | currency({
												symbol: currencyForZReportView, fractionCount: 2, symbolPosition: 'back',
												thousandsSeparator: ' '
											}) }}</span>
										</b>
									</td>
								</tr>
								<tr class="success">
									<th>
										Общая сумма возврата
									</th>
									<td>
										<b><span class="display_currency" data-currency_symbol="true">{{ zReport.qaytarishSum | currency({
							symbol: currencyForZReportView, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
						}) }} </span></b>
									</td>
								</tr>
<!--								<tr class="success">-->
<!--									<th>-->
<!--										Общая сумма скидки-->
<!--									</th>-->
<!--									<td>-->
<!--										<b><span class="display_currency" data-currency_symbol="true">{{zReport.promoSum | currency({-->
<!--												symbol: currencyForZReportView, fractionCount: 2, symbolPosition: 'back',-->
<!--												thousandsSeparator: ' '-->
<!--											}) }}</span>-->
<!--										</b>-->
<!--									</td>-->
<!--								</tr>-->
								<tr class="success">
									<th>
										Общая кол-во товаров
									</th>
									<td>
										<b><span class="display_currency" data-currency_symbol="true">{{ zReport.count }}</span>
										</b>
									</td>
								</tr>
								<tr class="success">
									<th>
										Общая кол-во возврат товаров
									</th>
									<td>
										<b><span class="display_currency" data-currency_symbol="true">{{ zReport.qaytarishCount }}</span>
										</b>
									</td>
								</tr>
								</tbody>
							</table>
						</template>
						<template v-else>
							<b-alert variant="info" show>Продажи еще не сделаны</b-alert>
						</template>
					</div>
				</div>
				<div class="col-sm-12">
					<b>Кассир:</b> {{this.zReport.cashierFullName}} <br>
				</div>

			</div>
		</div>
		<div class="modal-footer pb-0 hidden-print">
			<!--		<button type="submit"  class="btn btn-primary" id="pos-save">Распечатать</button>-->
			<!--<button type="button" @click="close" class="btn btn-info" data-dismiss="modal">Закрыть</button>-->

		</div>
	</div>
</template>

<script>
	import {mapGetters, mapActions, mapState} from 'vuex'
	import {TokenService} from "../../../services/storage.service";

	export default {
		name: 'ZReportView',
		props: {
			zReport: {
				type: Object,
				default: {}
			},
            currencyForZReportView: {
			    type: String,
				default: ''
			}
		},
		created() {

			// this.getZReport(TokenService.getDepartmentId())
		},

		computed: {
			...mapGetters('posReport', {
				'paymentTypeCard': 'getPaymentTypeCard'
			}),

			...mapState('pos', {
				'cashier': 'cashierFullName'
			}),
			...mapGetters('zetReport', {
				'currentZetReport': 'getZetReport'
			}),

		},

		methods: {
			...mapActions('zetReport', ['getZReport']),
			close() {
				this.$emit('close', true)
			},
			currentDate() {
				let now = new Date();
				let year = now.getFullYear();
				let month = now.getMonth() + 1;
				let day = now.getDate();
				let hour = now.getHours();
				let minute = now.getMinutes();
				let second = now.getSeconds();
				if (month.toString().length == 1) {
					month = '0' + month;
				}
				if (day.toString().length == 1) {
					day = '0' + day;
				}
				if (hour.toString().length == 1) {
					hour = '0' + hour;
				}
				if (minute.toString().length == 1) {
					minute = '0' + minute;
				}
				if (second.toString().length == 1) {
					second = '0' + second;
				}
				return day + '-' + month + '-' + year + ' ' + hour + ':' + minute + ':' + second;
			},
		}
	}
</script>

<style scoped>
	.box-z-report {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		border-bottom-right-radius: 3px;
		border-bottom-left-radius: 3px;
		padding: 10px;
	}

	.alert {
		padding: 15px;
	}

</style>
